<button type="button" (click)="selected.emit(id())">
  {{ shortId() }}
</button>
